import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({});

export const Unauthorized = withStyles(styles)(props => {
  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <div
        style={{
          marginBottom: 25,
          marginTop: -100,
          fontSize: '5em',
          fontWeight: 'bold',
          color: 'var(--jmi-blue)',
        }}
      >
        401
      </div>
      <div>You are not authorized to view this page.</div>
    </div>
  );
});
